/* ============================================================
 * Slowride in-stock-by-size collection filter
 *
 * Shopify's Search & Discovery filters by option value but does NOT
 * cross-check variant availability. This script post-processes a
 * filtered collection page: when an option filter is active (e.g.
 * size=Large), it hides product cards whose matching option value is
 * NOT available (variant.available === false).
 *
 * Setup:
 *   - sections/main-collection.liquid builds a `variant_availability`
 *     JSON map per product, keyed by handleized option name, with an
 *     array of in-stock option values.
 *     Example: { "size": ["S","M","XL"], "color": ["black"] }
 *   - product-card.liquid emits that as the data attribute
 *     `data-product-options-availability` on each card root.
 *   - This script reads URL params matching `filter.v.option.<name>`
 *     and hides cards where any active option filter's value is NOT
 *     in that card's availability list for the same option.
 *
 * Caveat: pagination drift. Shopify still paginates the unfiltered set
 * server-side; hiding cards client-side will reduce the visible count
 * within a page. The "showing N products" total may overstate the
 * visible count. We patch the on-page counter when present.
 * ============================================================ */
(function () {
  const FILTER_PARAM_PREFIX = 'filter.v.option.';

  function getActiveOptionFilters() {
    const params = new URLSearchParams(window.location.search);
    const filters = {};
    for (const [key, value] of params.entries()) {
      if (!key.startsWith(FILTER_PARAM_PREFIX)) continue;
      const optionHandle = key.slice(FILTER_PARAM_PREFIX.length).toLowerCase();
      if (!filters[optionHandle]) filters[optionHandle] = [];
      filters[optionHandle].push(value);
    }
    return filters;
  }

  function applyStockFilter() {
    const filters = getActiveOptionFilters();
    const cards = document.querySelectorAll('[data-product-options-availability]');
    if (cards.length === 0) return;

    let visibleCount = 0;
    let hiddenCount = 0;

    cards.forEach((card) => {
      let availability;
      try {
        availability = JSON.parse(card.getAttribute('data-product-options-availability') || '{}');
      } catch (e) {
        availability = {};
      }

      let shouldHide = false;
      for (const [optionHandle, activeValues] of Object.entries(filters)) {
        // Only enforce stock-check for options the product actually has
        const productAvailableValues = availability[optionHandle];
        if (!productAvailableValues) continue; // product has no such option; let it through

        // If any active filter value for this option is NOT in the available list, hide
        const allActiveValuesAvailable = activeValues.every((v) => productAvailableValues.includes(v));
        if (!allActiveValuesAvailable) {
          shouldHide = true;
          break;
        }
      }

      if (shouldHide) {
        card.parentElement?.setAttribute('data-stock-filter-hidden', 'true');
        card.parentElement && (card.parentElement.style.display = 'none');
        hiddenCount += 1;
      } else {
        card.parentElement?.removeAttribute('data-stock-filter-hidden');
        if (card.parentElement) card.parentElement.style.display = '';
        visibleCount += 1;
      }
    });

    // Patch product count if present
    const countEl = document.querySelector('[data-product-count], .collection__count, #ProductCount');
    if (countEl && hiddenCount > 0) {
      // Append a small note rather than overwriting the official Shopify count
      const note = countEl.querySelector('.stock-filter-note');
      if (note) note.remove();
      const span = document.createElement('span');
      span.className = 'stock-filter-note';
      span.style.marginInlineStart = '6px';
      span.style.opacity = '0.7';
      span.textContent = `(${visibleCount} in stock for selected filter)`;
      countEl.appendChild(span);
    }
  }

  // Run on initial load and after Concept's AJAX collection re-render
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyStockFilter);
  } else {
    applyStockFilter();
  }
  document.addEventListener('collection:reloaded', applyStockFilter);
})();
